import { loadable } from '@shared/core/loadableFromNamedExport';

// Experiment-gated (`marriottroomblockbanner` treatment): kept out of the guest bundle for everyone else.
export const LazyMarriottRoomBlockBanner = loadable(
  () => import(/* webpackChunkName: "content/guest/marriottRoomBlockBanner" */ './MarriottRoomBlockBanner'),
  'MarriottRoomBlockBanner',
);
